import React from "react";
import { Link } from "react-router-dom";

const AIFeatures = () => {
  const features = [
    {
      icon: "🤖",
      title: "AI Test Generation",
      description:
        "Transform user stories into comprehensive test suites automatically. Supports Playwright, Cypress, Jest, and more.",
      link: "/ai-test-generation",
      badge: "NEW",
      gradient: "from-green-400 to-blue-500",
    },
    {
      icon: "🔍",
      title: "Smart Test Analysis",
      description:
        "AI-powered analysis of test results, identifying patterns and suggesting improvements.",
      link: "#",
      badge: "COMING SOON",
      gradient: "from-purple-400 to-pink-500",
    },
    {
      icon: "⚡",
      title: "Flaky Test Detector",
      description:
        "Automatically identify and fix flaky tests using machine learning algorithms.",
      link: "#",
      badge: "COMING SOON",
      gradient: "from-orange-400 to-red-500",
    },
  ];

  return (
    <section id="ai-features" className="py-16 md:py-24">
      <div className="text-center mb-12">
        <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
          AI-Powered <span className="text-gradient">Testing Suite</span>
        </h2>
        <p className="text-xl text-gray-400 max-w-3xl mx-auto">
          Harness the power of Generative AI to revolutionize your testing
          workflow. Our intelligent tools understand your requirements and
          generate production-ready test code.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {features.map((feature, index) => (
          <div
            key={index}
            className="card p-8 text-center hover:scale-105 transition-transform duration-300"
          >
            <div className="relative inline-block mb-6">
              <div className="text-5xl mb-2">{feature.icon}</div>
              <span
                className={`absolute -top-2 -right-2 bg-gradient-to-r ${feature.gradient} text-black px-2 py-1 rounded-full text-xs font-bold`}
              >
                {feature.badge}
              </span>
            </div>

            <h3 className="text-2xl font-semibold text-white mb-4">
              {feature.title}
            </h3>

            <p className="text-gray-400 mb-6 leading-relaxed">
              {feature.description}
            </p>

            {feature.link === "#" ? (
              <button
                disabled
                className="px-6 py-3 bg-gray-700 text-gray-400 font-medium rounded-lg cursor-not-allowed"
              >
                Coming Soon
              </button>
            ) : (
              <Link
                to={feature.link}
                className={`inline-flex items-center px-6 py-3 bg-gradient-to-r ${feature.gradient} text-black font-bold rounded-lg hover:scale-105 transition-transform`}
              >
                Try Now
                <svg
                  className="w-5 h-5 ml-2"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M13 7l5 5m0 0l-5 5m5-5H6"
                  />
                </svg>
              </Link>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default AIFeatures;
